interface HeadMeta {
  title: string;
  description: string;
  canonical: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
}

function setMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function setHeadMeta({ title, description, canonical, ogTitle, ogDescription, ogType }: HeadMeta) {
  document.title = title;
  setMeta("name", "description", description);
  setMeta("property", "og:title", ogTitle ?? title);
  setMeta("property", "og:description", ogDescription ?? description);
  setMeta("property", "og:type", ogType ?? "website");
  setMeta("property", "og:url", canonical);
  setMeta("name", "twitter:title", ogTitle ?? title);
  setMeta("name", "twitter:description", ogDescription ?? description);

  let link = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", canonical);
}